import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import {
  FDBodyText,
  FDClickableText,
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('RequestChurnWithConcessionsReasonsStepLayout', ((theme) => ({
  reasonContainer: {
    '& > * > .FD-MuiFormGroup-root': {
      paddingLeft: 0,
      paddingRight: 0,
    },
    '& .FD-MuiPaper-root .FD-MuiButtonBase-root': { // Hack to make the background color of the big picklist inputs match the background color
      backgroundColor: theme.palette.facet.lightGray,
    },
  },
})));

export default function RequestChurnWithConcessionsReasonsStepLayout() {
  const {
    resource, onSubmit, saving,
  } = useMetaLayoutContext();
  const classes = useStyles();
  const { clearModalCollection } = useModalContext();

  return (
    <>
      <MetaControlField attr="title" />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={2}>
          <MetaControlField attr="description" />
          <div className={classes.reasonContainer}>
            <MetaControlField attr="reason" />
          </div>
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDStack direction="column" spacing={2} flex={1}>
          {resource.meta().canPost() ? <FDPrimaryActionButton flex={1} loading={saving} label="Continue" onClick={onSubmit} /> : null}
          <FDBodyText align="start" color="textSecondary" value={<FDClickableText appearance="standalone" label="I don't want to cancel" onClick={clearModalCollection} />} />
        </FDStack>
      </DialogActions>
    </>
  );
}
